import { useEffect, useState } from "react";
import { styled } from "@mui/material";
import { userProfile } from "../../libs/UserProfile";
import useAuthProvider from "./Authorization/auth-provider-hook";
import ProfileEndpoint from "../../libs/ProfileEndpoint";
import Loading from "../Common/Loading";
import { logEvent } from "../../libs/amplitude";
import Github from "../../libs/GithubClient";

const DiscordAuthWrapper = styled("div")({
  position: "fixed",
  height: "100%",
  width: "100%",
  backgroundColor: "#121212",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const ReAuthentication = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const user = userProfile(localStorage);
  const authProvider = useAuthProvider();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code");
    const type = queryParams.get("type");

    const connectGithub = async () => {
      setIsProcessing(true);
      const tokenResponse = await Github.saveAccessToken(code);
      const saveToken = await ProfileEndpoint.updateGithubToken(
        tokenResponse.token
      );
      if (saveToken) {
        user.setGithubUsername(tokenResponse.userId);
      }

      logEvent("Connected Github", user.userId());
      setIsProcessing(false);
      if (window.opener?.location?.href?.startsWith(window.location.origin)) {
        window.opener?.postMessage("success", "*");
        window.close();
      }
    };

    if (type === "connectGithub" && code) {
      connectGithub();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!authProvider) return;

    const queryParams = new URLSearchParams(window.location.search);
    const type = queryParams.get("type");

    const addCodespaces = async () => {
      setIsProcessing(true);
      const tokenResponse = await authProvider.getAccessToken();
      if (user.provider() === "github") {
        authProvider.setUserInfo(tokenResponse);
      }

      await ProfileEndpoint.updateGithubToken(tokenResponse.token);
      logEvent("Authorized Codespace", user.userId());

      user.setGithubScopes(tokenResponse?.scope);
      setIsProcessing(false);
      if (window.opener?.location?.href?.startsWith(window.location.origin)) {
        window.opener?.postMessage("success", "*");
        window.close();
      }
    };

    if (type === "addCodespaces") {
      addCodespaces();
    }
    // eslint-disable-next-line
  }, [authProvider]);

  return <DiscordAuthWrapper>{isProcessing && <Loading />}</DiscordAuthWrapper>;
};

export default ReAuthentication;
